import { lighten } from '@mui/material/styles';

export const safeLighten = (color: string, amount: number) => {
  if (!color) return color;

  try {
    return lighten(color, amount);
  } catch {
    return color;
  }
};
